/*
Defines the custom element <ravel-tally-grid>
*/

import { RavelTallyGrid } from './src/RavelTallyGrid.js';

customElements.define('ravel-tally-grid', RavelTallyGrid);
